import styled from 'styled-components'

import rem from '../../../styles/tools/rem'
import em from '../../../styles/tools/em'

import { title28GalanoBold, txt16OpenSansBold } from '../../../styles/settings/types'

import { darkSlateBlue } from '../../../styles/settings/colors'

export const Title = styled.h1`
  letter-spacing: ${em('0.4px')};
  color: ${darkSlateBlue};
  margin-top: ${rem('25px')};
  margin-bottom: ${rem('30px')};
  ${title28GalanoBold};
  letter-spacing: normal;
  line-height: 1;
`

export const Container = styled.section`
  width: 100%;
  padding: ${rem('9px')} 0 ${rem('17px')};
  background-color: white;
  display: flex;
  justify-content: center;
`

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: ${rem('940px')};
`

export const FilterTypeContainer = styled.div`
  padding: 0;
  overflow: auto;
`

export const FilterTypes = styled.ul`
  display: flex;
  justify-content: flex-start;
  list-style: none;
  margin: 0;
  min-height: ${rem('56px')};
  padding: 0;
  width: 100%;
  align-items: center;
`

export const ListItem = styled.li`
  margin-right: 40px;
`

export const InputRadio = styled.input.attrs({
  type: 'radio'
})`
  display: none;
`

export const CheckMark = styled.span`
  border-radius: 30px;
  width: 7px;
  height: 7px;
  position: absolute;
  top: 6px;
  left: 6px;
  content: ' ';
  background: white;
  display: block;
  z-index: 1;
`

export const Radio = styled.span`
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0 5px 0 0;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  border: 2px solid #004c97;
  background-color: ${({ isSelected }) => (isSelected ? darkSlateBlue : `transparent`)};
`
export const RadioLabel = styled.label`
  position: relative;
  color: ${darkSlateBlue};
  ${txt16OpenSansBold};
  padding-left: 30px;
`



// WEBPACK FOOTER //
// ./src/app/modules/FilterByPeriod/styles.js